// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/rfi_evidence.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { LibraryReleaseContext } from "./library_release_pb";
/**
 * @generated from message mono.datagateway.v1.RfiEvidenceSource
 */ export class RfiEvidenceSource extends Message {
    static fromBinary(bytes, options) {
        return new RfiEvidenceSource().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiEvidenceSource().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiEvidenceSource().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiEvidenceSource, a, b);
    }
    constructor(data){
        super(), /**
   * artifact or library_release. Identities are mutually exclusive and checked.
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string library_item_id = 2;
   */ _define_property(this, "libraryItemId", ""), /**
   * @generated from field: string release_id = 3;
   */ _define_property(this, "releaseId", ""), /**
   * @generated from field: int32 release_version = 4;
   */ _define_property(this, "releaseVersion", 0), /**
   * @generated from field: string reuse_id = 5;
   */ _define_property(this, "reuseId", ""), /**
   * @generated from field: string artifact_id = 6;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: int32 artifact_version = 7;
   */ _define_property(this, "artifactVersion", 0), /**
   * @generated from field: string sha256 = 8;
   */ _define_property(this, "sha256", ""), /**
   * @generated from field: string location = 9;
   */ _define_property(this, "location", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiEvidenceSource, "runtime", proto3);
_define_property(RfiEvidenceSource, "typeName", "mono.datagateway.v1.RfiEvidenceSource");
_define_property(RfiEvidenceSource, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "release_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "reuse_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "artifact_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "location",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RfiEvidenceDraft
 */ export class RfiEvidenceDraft extends Message {
    static fromBinary(bytes, options) {
        return new RfiEvidenceDraft().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiEvidenceDraft().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiEvidenceDraft().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiEvidenceDraft, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string question_id = 3;
   */ _define_property(this, "questionId", ""), /**
   * @generated from field: string document_id = 4;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string base_version_id = 5;
   */ _define_property(this, "baseVersionId", ""), /**
   * manual has no conversation/tool IDs; framework requires both.
   *
   * @generated from field: string provenance = 6;
   */ _define_property(this, "provenance", ""), /**
   * @generated from field: string conversation_id = 7;
   */ _define_property(this, "conversationId", ""), /**
   * @generated from field: string tool_call_id = 8;
   */ _define_property(this, "toolCallId", ""), /**
   * Review history only. Canonical published bytes stay in Office.
   *
   * @generated from field: string proposed_text = 9;
   */ _define_property(this, "proposedText", ""), /**
   * @generated from field: string proposed_content_sha256 = 10;
   */ _define_property(this, "proposedContentSha256", ""), /**
   * @generated from field: repeated mono.datagateway.v1.RfiEvidenceSource basis = 11;
   */ _define_property(this, "basis", []), /**
   * @generated from field: repeated string material_gaps = 12;
   */ _define_property(this, "materialGaps", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiEvidenceDraft, "runtime", proto3);
_define_property(RfiEvidenceDraft, "typeName", "mono.datagateway.v1.RfiEvidenceDraft");
_define_property(RfiEvidenceDraft, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "conversation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "tool_call_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "proposed_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "proposed_content_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "basis",
            kind: "message",
            T: RfiEvidenceSource,
            repeated: true
        },
        {
            no: 12,
            name: "material_gaps",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RfiEvidencePublication
 */ export class RfiEvidencePublication extends Message {
    static fromBinary(bytes, options) {
        return new RfiEvidencePublication().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiEvidencePublication().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiEvidencePublication().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiEvidencePublication, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string draft_id = 2;
   */ _define_property(this, "draftId", ""), /**
   * @generated from field: string decision = 3;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: string document_id = 4;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string base_version_id = 5;
   */ _define_property(this, "baseVersionId", ""), /**
   * @generated from field: string document_version_id = 6;
   */ _define_property(this, "documentVersionId", ""), /**
   * @generated from field: string content_sha256 = 7;
   */ _define_property(this, "contentSha256", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiEvidencePublication, "runtime", proto3);
_define_property(RfiEvidencePublication, "typeName", "mono.datagateway.v1.RfiEvidencePublication");
_define_property(RfiEvidencePublication, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "document_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "content_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegisterRfiDraftRequest
 */ export class RegisterRfiDraftRequest extends Message {
    static fromBinary(bytes, options) {
        return new RegisterRfiDraftRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegisterRfiDraftRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegisterRfiDraftRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegisterRfiDraftRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: mono.datagateway.v1.RfiEvidenceDraft draft = 2;
   */ _define_property(this, "draft", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegisterRfiDraftRequest, "runtime", proto3);
_define_property(RegisterRfiDraftRequest, "typeName", "mono.datagateway.v1.RegisterRfiDraftRequest");
_define_property(RegisterRfiDraftRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "draft",
            kind: "message",
            T: RfiEvidenceDraft
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegisterRfiDraftResponse
 */ export class RegisterRfiDraftResponse extends Message {
    static fromBinary(bytes, options) {
        return new RegisterRfiDraftResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegisterRfiDraftResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegisterRfiDraftResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegisterRfiDraftResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiEvidenceDraft draft = 1;
   */ _define_property(this, "draft", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegisterRfiDraftResponse, "runtime", proto3);
_define_property(RegisterRfiDraftResponse, "typeName", "mono.datagateway.v1.RegisterRfiDraftResponse");
_define_property(RegisterRfiDraftResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "draft",
            kind: "message",
            T: RfiEvidenceDraft
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReviewRfiDraftRequest
 */ export class ReviewRfiDraftRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviewRfiDraftRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewRfiDraftRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewRfiDraftRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewRfiDraftRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string draft_id = 3;
   */ _define_property(this, "draftId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewRfiDraftRequest, "runtime", proto3);
_define_property(ReviewRfiDraftRequest, "typeName", "mono.datagateway.v1.ReviewRfiDraftRequest");
_define_property(ReviewRfiDraftRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReviewRfiDraftResponse
 */ export class ReviewRfiDraftResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviewRfiDraftResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewRfiDraftResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewRfiDraftResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewRfiDraftResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiEvidenceDraft draft = 1;
   */ _define_property(this, "draft", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewRfiDraftResponse, "runtime", proto3);
_define_property(ReviewRfiDraftResponse, "typeName", "mono.datagateway.v1.ReviewRfiDraftResponse");
_define_property(ReviewRfiDraftResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "draft",
            kind: "message",
            T: RfiEvidenceDraft
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DecideRfiDraftRequest
 */ export class DecideRfiDraftRequest extends Message {
    static fromBinary(bytes, options) {
        return new DecideRfiDraftRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideRfiDraftRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideRfiDraftRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideRfiDraftRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string draft_id = 3;
   */ _define_property(this, "draftId", ""), /**
   * accepted, edited or rejected. This never approves submission.
   *
   * @generated from field: string decision = 4;
   */ _define_property(this, "decision", ""), /**
   * Explicitly reviewed DOCX. accepted must match the registered hash; edited
   * adopts the explicitly supplied human edit. rejected requires empty content.
   *
   * @generated from field: bytes reviewed_content = 5;
   */ _define_property(this, "reviewedContent", new Uint8Array(0)), /**
   * Set by the public projectdata facade. Enforced against stored provenance
   * before any decision or Office write, including rejection after revocation.
   * Framework decisions must use the owned saved-proposal adapter instead.
   *
   * @generated from field: bool manual_only = 6;
   */ _define_property(this, "manualOnly", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideRfiDraftRequest, "runtime", proto3);
_define_property(DecideRfiDraftRequest, "typeName", "mono.datagateway.v1.DecideRfiDraftRequest");
_define_property(DecideRfiDraftRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reviewed_content",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 6,
            name: "manual_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DecideRfiDraftResponse
 */ export class DecideRfiDraftResponse extends Message {
    static fromBinary(bytes, options) {
        return new DecideRfiDraftResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideRfiDraftResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideRfiDraftResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideRfiDraftResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiEvidencePublication publication = 1;
   */ _define_property(this, "publication", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideRfiDraftResponse, "runtime", proto3);
_define_property(DecideRfiDraftResponse, "typeName", "mono.datagateway.v1.DecideRfiDraftResponse");
_define_property(DecideRfiDraftResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "publication",
            kind: "message",
            T: RfiEvidencePublication
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RenderRfiOutwardRequest
 */ export class RenderRfiOutwardRequest extends Message {
    static fromBinary(bytes, options) {
        return new RenderRfiOutwardRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RenderRfiOutwardRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RenderRfiOutwardRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RenderRfiOutwardRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string draft_id = 3;
   */ _define_property(this, "draftId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RenderRfiOutwardRequest, "runtime", proto3);
_define_property(RenderRfiOutwardRequest, "typeName", "mono.datagateway.v1.RenderRfiOutwardRequest");
_define_property(RenderRfiOutwardRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RenderRfiOutwardResponse
 */ export class RenderRfiOutwardResponse extends Message {
    static fromBinary(bytes, options) {
        return new RenderRfiOutwardResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RenderRfiOutwardResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RenderRfiOutwardResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RenderRfiOutwardResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiEvidencePublication publication = 1;
   */ _define_property(this, "publication", void 0), /**
   * Real canonical saved DOCX, only when fully published, current and eligible.
   * Exclusion omits the whole prose, never just its citation labels.
   *
   * @generated from field: bytes content = 2;
   */ _define_property(this, "content", new Uint8Array(0)), /**
   * @generated from field: string exclusion_reason = 3;
   */ _define_property(this, "exclusionReason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RenderRfiOutwardResponse, "runtime", proto3);
_define_property(RenderRfiOutwardResponse, "typeName", "mono.datagateway.v1.RenderRfiOutwardResponse");
_define_property(RenderRfiOutwardResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "publication",
            kind: "message",
            T: RfiEvidencePublication
        },
        {
            no: 2,
            name: "content",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 3,
            name: "exclusion_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * NEXT Shanks: resolve each selected source as the current user, bind its exact
 * identity plus RFI/section/question/document/base to the owned SAVED tool
 * proposal, render DOCX and hash those bytes. Only then service-authenticated
 * RegisterRfiDraft(provenance=framework, conversation_id, tool_call_id). Never
 * accept browser assertions of ownership, provenance, hash or tool contents.
 * Accept/Reject MUST invoke DecideRfiDraft with the same target/draft: accepted
 * sends registered DOCX bytes; edited sends explicitly reviewed DOCX; rejected
 * sends no content. Never write Office/answer/citation state directly. Retry the
 * same identity/bytes after interruption; a changed base requires fresh review.
 *
 * @generated from message mono.datagateway.v1.ResolveRfiEvidenceContextRequest
 */ export class ResolveRfiEvidenceContextRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveRfiEvidenceContextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveRfiEvidenceContextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveRfiEvidenceContextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveRfiEvidenceContextRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string question_id = 3;
   */ _define_property(this, "questionId", ""), /**
   * @generated from field: mono.datagateway.v1.RfiEvidenceSource source = 4;
   */ _define_property(this, "source", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveRfiEvidenceContextRequest, "runtime", proto3);
_define_property(ResolveRfiEvidenceContextRequest, "typeName", "mono.datagateway.v1.ResolveRfiEvidenceContextRequest");
_define_property(ResolveRfiEvidenceContextRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source",
            kind: "message",
            T: RfiEvidenceSource
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ResolveRfiEvidenceContextResponse
 */ export class ResolveRfiEvidenceContextResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveRfiEvidenceContextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveRfiEvidenceContextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveRfiEvidenceContextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveRfiEvidenceContextResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string question_id = 3;
   */ _define_property(this, "questionId", ""), /**
   * @generated from field: string document_id = 4;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string base_version_id = 5;
   */ _define_property(this, "baseVersionId", ""), /**
   * @generated from field: mono.datagateway.v1.RfiEvidenceSource source = 6;
   */ _define_property(this, "source", void 0), /**
   * @generated from field: string title = 7;
   */ _define_property(this, "title", ""), /**
   * @generated from field: bytes content = 8;
   */ _define_property(this, "content", new Uint8Array(0)), /**
   * @generated from field: string content_format = 9;
   */ _define_property(this, "contentFormat", ""), /**
   * @generated from field: mono.datagateway.v1.LibraryReleaseContext release_context = 10;
   */ _define_property(this, "releaseContext", void 0), /**
   * resolved or frozen_snapshot. Artifact eligibility is unknown: internal
   * permission is NOT permission for external output. Library context carries
   * the established explicit eligibility/restrictions decision.
   *
   * @generated from field: string reuse_status = 11;
   */ _define_property(this, "reuseStatus", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveRfiEvidenceContextResponse, "runtime", proto3);
_define_property(ResolveRfiEvidenceContextResponse, "typeName", "mono.datagateway.v1.ResolveRfiEvidenceContextResponse");
_define_property(ResolveRfiEvidenceContextResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source",
            kind: "message",
            T: RfiEvidenceSource
        },
        {
            no: 7,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "content",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 9,
            name: "content_format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "release_context",
            kind: "message",
            T: LibraryReleaseContext
        },
        {
            no: 11,
            name: "reuse_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRfiEvidenceStateRequest
 */ export class GetRfiEvidenceStateRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiEvidenceStateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiEvidenceStateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiEvidenceStateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiEvidenceStateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiEvidenceStateRequest, "runtime", proto3);
_define_property(GetRfiEvidenceStateRequest, "typeName", "mono.datagateway.v1.GetRfiEvidenceStateRequest");
_define_property(GetRfiEvidenceStateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RfiEvidenceHistory
 */ export class RfiEvidenceHistory extends Message {
    static fromBinary(bytes, options) {
        return new RfiEvidenceHistory().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiEvidenceHistory().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiEvidenceHistory().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiEvidenceHistory, a, b);
    }
    constructor(data){
        super(), /**
   * Withheld entries carry target/draft identity only, never derived prose,
   * hidden source identities/counts, gaps or titles. History stays in the DB.
   *
   * @generated from field: mono.datagateway.v1.RfiEvidenceDraft draft = 1;
   */ _define_property(this, "draft", void 0), /**
   * empty (pending), accepted, edited, rejected
   *
   * @generated from field: string decision = 2;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: mono.datagateway.v1.RfiEvidencePublication publication = 3;
   */ _define_property(this, "publication", void 0), /**
   * @generated from field: bool evidence_withheld = 4;
   */ _define_property(this, "evidenceWithheld", false), /**
   * durable aggregate flag, including after revocation
   *
   * @generated from field: bool source_withdrawn = 5;
   */ _define_property(this, "sourceWithdrawn", false), /**
   * canonical Office version AND hash match receipt
   *
   * @generated from field: bool current_answer = 6;
   */ _define_property(this, "currentAnswer", false), /**
   * @generated from field: bool outward_eligible = 7;
   */ _define_property(this, "outwardEligible", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiEvidenceHistory, "runtime", proto3);
_define_property(RfiEvidenceHistory, "typeName", "mono.datagateway.v1.RfiEvidenceHistory");
_define_property(RfiEvidenceHistory, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "draft",
            kind: "message",
            T: RfiEvidenceDraft
        },
        {
            no: 2,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "publication",
            kind: "message",
            T: RfiEvidencePublication
        },
        {
            no: 4,
            name: "evidence_withheld",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "source_withdrawn",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "current_answer",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "outward_eligible",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRfiEvidenceStateResponse
 */ export class GetRfiEvidenceStateResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiEvidenceStateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiEvidenceStateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiEvidenceStateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiEvidenceStateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string current_version_id = 2;
   */ _define_property(this, "currentVersionId", ""), /**
   * oldest first, immutable decisions
   *
   * @generated from field: repeated mono.datagateway.v1.RfiEvidenceHistory history = 3;
   */ _define_property(this, "history", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiEvidenceStateResponse, "runtime", proto3);
_define_property(GetRfiEvidenceStateResponse, "typeName", "mono.datagateway.v1.GetRfiEvidenceStateResponse");
_define_property(GetRfiEvidenceStateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "current_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "history",
            kind: "message",
            T: RfiEvidenceHistory,
            repeated: true
        }
    ]));
